import { render, staticRenderFns } from "./MIGDashboard.vue?vue&type=template&id=0805c4c3&"
import script from "./MIGDashboard.vue?vue&type=script&lang=js&"
export * from "./MIGDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MIGDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports